import React from "react";
import CreatorVideoCard from "./CreatorVideoCard";
import CreatorVideoSkeleton from "components/skeleton/CreatorVideoSkeleton";
import NoSearch from "pages/searchPage/shared/NoSearch";

function VideoCardGrid({ creatorData, slug, isLoading }: any) {
  const videos = creatorData?.videos || [];
  return (
    <div>
      {!isLoading && (
        <>
          {videos.length === 0 && videos ? (
            <NoSearch text="Videos" />
          ) : (
            <div className="mb-4 mt-4 grid w-[95%] grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 max-sm:w-full">
              {videos?.map((video: any, index: any) => (
                <CreatorVideoCard
                  key={index}
                  video={video}
                  slug={creatorData?.general_info.slug}
                  isLoading={isLoading}
                />
              ))}
            </div>
          )}
        </>
      )}
      {isLoading && <CreatorVideoSkeleton />}
    </div>
  );
}

export default VideoCardGrid;